<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <!--工具条-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
        <el-form :inline="true" :model="filters" ref="filters">
          <!-- <el-form-item label="登录账号" prop="name">
            <el-input
              v-model="filters.name"
              placeholder="登录账号"
              style="min-width: 240px"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </el-form-item> -->
          <!-- <el-form-item>
            <el-button type="primary" @click="handleSearch">查询</el-button>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="showAddDialog">添加</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="btnme">测试</el-button>
          </el-form-item> -->
          <!-- <el-form-item>
            <el-button @click="resetForm('filters')">重置</el-button>
          </el-form-item> -->
        </el-form>
      </el-col>

      <!--列表-->
      <el-table :data="tasks" highlight-current-row v-loading="loading" style="width: 100%">
        <el-table-column label="序号" type="index" width="80">
        </el-table-column>
        <el-table-column prop="name" label="提醒标题"> </el-table-column>
        <el-table-column prop="begintime" :formatter="formatBegin" label="开始时间">
        </el-table-column>
        <el-table-column prop="endtime" :formatter="formatEnd" label="结束时间">
        </el-table-column>
        <!-- <el-table-column prop="state" label="当前状态"> </el-table-column> -->

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="showEditDialog(scope.$index, scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="removeUser(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>
      <!-- 添加界面 -->
      <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm" show-overflow-tooltip>
          <el-form-item label="提醒标题" prop="name">
            <el-input v-model="addForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item prop="value2" label="起始时间">
            <el-date-picker v-model="addForm.value2" type="datetimerange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>
      <!-- 编辑界面 -->
      <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm" show-overflow-tooltip>
          <el-form-item label="提醒标题" prop="name">
            <el-input v-model="editForm.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item prop="value2" label="起始时间">
            <el-date-picker v-model="editForm.value2" type="datetimerange" range-separator="至" start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click.native="editSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>
    </el-col>
  </el-row>
</template>

<script>
import API from "../../../api/frbasicapi/taskmanager";
import MallApi from "../../../api/goods/goodscateapi"

export default {
  data() {
    return {
      filters: {
        name: "",
      },

      loading: false,
      tasks: [],
      total: 0,
      page: 1,
      limit: 10,

      editFormVisible: false,
      editFormRules: {
        name: [{ required: true, message: "请输入标题", trigger: "blur" }],
        value2: [
          { required: true, message: "请选择起始时间", trigger: "blur" },
        ],
      },
      editForm: {},
      value: [],

      //新增相关数据
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入标题", trigger: "blur" }],
        value2: [
          { required: true, message: "请选择起始时间", trigger: "blur" },
        ],
      },
      addForm: {
        name: "",
        value2: "",
      },
    };
  },
  methods: {
    formatBegin: function (row, column) {
      return this.dateFormatString(row.begintime);
    },
    formatEnd: function (row, column) {
      return this.dateFormatString(row.endtime);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    handleSizeChange(val) {
      this.limit = val;
      this.search();
    },
    handleSearch() {
      this.total = 0;
      this.page = 1;
      this.search();
    },

    btnme: function () {
      let params = {
        name: '小老虎'
      };
      MallApi.get(params).then(function (result) {
        console.log(result)
      })
    },

    //获取用户列表
    search: function () {
      let that = this;
      let params = {
        pageNum: that.page,
        pageSize: 10,
        //name: that.filters.name,
      };

      that.loading = true;
      API.list(params)
        .then(
          function (result) {
            that.loading = false;
            if (result && result.data.totalSize) {
              that.total = result.data.totalSize;
              that.tasks = result.data.content;
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },
    showAddDialog: function () {
      this.addFormVisible = true;
    },
    showEditDialog: function (index, row) {
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      this.value[0] = this.editForm.begintime;
      this.value[1] = this.editForm.endtime;
      this.editForm.value2 = this.value;
    },
    dateFormatString(data) {
      var date = new Date(data);
      var month = date.getMonth() + 1;
      const time =
        date.getFullYear() +
        "-" +
        this.dateChange(month) +
        "-" +
        this.dateChange(date.getDate()) +
        " " +
        this.dateChange(date.getHours()) +
        ":" +
        this.dateChange(date.getMinutes()) +
        ":" +
        this.dateChange(date.getSeconds());
      return time;
    },

    dateChange(m) {
      return m < 10 ? "0" + m : m;
    },

    addSubmit: function () {
      let that = this;

      var begin = "";
      var end = "";
      if (this.addForm.value2 != "" && this.addForm.value2 != null) {
        begin = this.dateFormatString(
          this.addForm.value2.toString().split(",")[0]
        );
        end = this.dateFormatString(
          this.addForm.value2.toString().split(",")[1]
        );
      }

      this.addForm.value2 = begin + "," + end;

      this.$refs.addForm.validate((valid) => {
        if (valid) {
          // that.loading = true;
          API.add(this.addForm).then(function (result) {
            if (0 === result.code) {
              that.loading = false;
              that.$message;
              that.$message.success({
                showClose: true,
                message: "新增成功",
                duration: 2000,
              });
              that.$refs["addForm"].resetFields();
              that.addFormVisible = false;
              that.search();
            } else {
              that.$message.error({
                showClose: true,
                message: result.msg || "新增失败",
                duration: 2000,
              });
            }
          });
        }
      });
    },
    editSubmit: function () {
      let that = this;

      var begin = "";
      var end = "";
      if (this.editForm.value2 != "" && this.editForm.value2 != null) {
        begin = this.dateFormatString(
          this.editForm.value2.toString().split(",")[0]
        );
        end = this.dateFormatString(
          this.editForm.value2.toString().split(",")[1]
        );
      }
      this.editForm.value2 = begin + "," + end;

      this.$refs.editForm.validate((valid) => {
        if (valid) {
          //that.loading = true;
          API.update(this.editForm).then(function (result) {
            if (0 === result.code) {
              that.loading = false;
              that.$message;
              that.$message.success({
                showClose: true,
                message: "修改成功",
                duration: 2000,
              });
              that.$refs["editForm"].resetFields();
              that.editFormVisible = false;
              that.search();
            } else {
              that.$message.error({
                showClose: true,
                message: result.msg,
                duration: 2000,
              });
            }
          });
        }
      });
    },

    removeUser: function (index, row) {
      let that = this;
      this.$confirm("确认删除该记录吗?", "提示", { type: "warning" })
        .then(() => {
          that.loading = true;
          API.delete({ id: row.id })
            .then(
              function (result) {
                that.loading = false;
                if (result && parseInt(result.code) === 0) {
                  that.$message.success({
                    showClose: true,
                    message: "删除成功",
                    duration: 1500,
                  });
                  that.search();
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000,
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000,
              });
            });
        })
        .catch(() => { });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$nextTick(() => { });
    },
  },

  mounted() {
    this.handleSearch();
  },
};
</script>

<style scoped>

</style>
